export const createEvent = (event) => {
  event && event();
};
